module.exports = __webpack_public_path__ + "83eb406e8fbcbbbea0cdd34fe7a80d4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/ComeBack/assets/sec-4/adidas.jpg
// module id = ./app/containers/StaticPage/ComeBack/assets/sec-4/adidas.jpg
// module chunks = 40